<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.zdBoxBreadCrumb" />
    </div>

    <div
        class="list-content-div"
        style="flex-direction: column; justify-content: space-between"
    >
      <div style="height: 100%;">
        <div class="list-header-title-div">储能充放策略</div>

        <div class="list-table">
          <!--表格区-->
          <el-button type="primary" size="small" :disabled="!isFlag" @click="addTime">增加时间段</el-button>

          <el-table :data="listData" :stripe="true" class="list_tb" border>
            <el-table-column prop="yearMon" label="时段" min-width="140" align="center">
              <template slot-scope="scope">
                <div v-if="isFlag && scope.row.clickEdit" style="width: 100%; display: flex; align-items: center; justify-content: center;">
                  <el-time-picker v-model="scope.row.startTime" value-format="HH 点" format="HH 点" placeholder="任意时间点"/>
                  <div style="margin: 0 16px"> - </div>
                  <el-time-picker v-model="scope.row.endTime" value-format="HH 点" format="HH 点" placeholder="任意时间点"/>
                </div>
                <div v-else>{{ scope.row.startTime }} - {{ scope.row.endTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="chargeElecAll" label="充放类型" min-width="140" align="center">
              <template slot-scope="scope">
                <div v-if="isFlag && scope.row.clickEdit">
                  <el-select v-model="scope.row.select">
                    <el-option v-for="item in disChargeType" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </div>
                <div v-else>{{ scope.row.startTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="chargeElecAll" label="SOC(结束条件)" min-width="140" align="center">
              <template slot-scope="scope">
                <div v-if="isFlag && scope.row.clickEdit">
                  <el-input v-model="scope.row.soc">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div v-else>{{ scope.row.startTime }} %</div>
              </template>
            </el-table-column>
            <el-table-column prop="ammeterElecAll" label="操作" min-width="120" align="center">
              <template slot-scope="scope">
                <el-button :disabled="!isFlag" type="text" size="small" @click="handleEdit(scope.row)">{{ scope.row.clickEdit ? '提 交' : '编 辑' }}</el-button>
                <el-button :disabled="!isFlag" type="text" size="small" @click="handleDel(scope.row)">删 除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 系统配置文件
  import pageConfig from "./page-config";

  export default {
    data() {
      return {
        pageConfig: pageConfig, // 页面配置

        isFlag: false, // 用户是否有权限编辑
        listData: [], // 列表数据
        disChargeType: [
          {
            value: '01',
            label: '充电'
          },
          {
            value: '02',
            label: '放电'
          },
        ], // 充放类型
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      // 初始化
      init() {
        let _ = this;
        _.isFlag = _.$S.checkUserMenu("pileStationAdd");
        console.log(_.isFlag, '0')
      },

      // 页面初始化
      initList(pagination, reload = false) {
        // 列表查询渲染
        let _ = this;
        _.$U.showLoading(_);
        _.queryInfo.pageNum = pagination.current - 1;
        if (reload) {
          pagination.current = 1;
          _.queryInfo.pageNum = 0;
        }
        _.queryInfo.pageSize = pagination.pageSize;
        // 表格数据
        _.$H
          .post(_, _.$A.ammeterFeeRecord.page, JSON.stringify(_.queryInfo))
          .then(res => {
            let list = res.data.data.content || [];
            if (list.length != 0) {
              _.listData = list.filter(item => item.elecNo == _.queryInfo.elecNo);
            } else {
              _.listData = list;
            }
            _.pagination.total = _.listData.length;
            _.$U.hideLoading(_);
          });
      },

      // 增加时间段
      addTime() {
        let _ = this,
          newItems = {
            startTime: '',
            endTime: '',
            clickEdit: true,
          };
        if( _.listData.length > 0 ){
          newItems.startTime = _.listData[_.listData.length - 1].endTime;
        }
        _.listData.push(newItems);
      },

      // 编辑
      handleEdit(row) {
        let _ = this;
        row.clickEdit = !row.clickEdit;
      },

      // 删除
      handleDel(row) {
        console.log(row, 'row')
      },
    }
  };
</script>

<style lang="less" scoped>
  .list-table {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 24px;
  }
</style>
